import { css as r } from "../stitches.config.es.js";
const o = r({
  display: "inline-flex",
  alignItems: "center"
}), i = r({
  all: "unset",
  cursor: "pointer",
  width: "1.125rem",
  height: "1.125rem",
  opacity: "0.8",
  borderRadius: "0.125rem",
  border: "solid 1px $coreGreys50",
  backgroundColor: "$lightBg100Main",
  boxSizing: "border-box",
  flexShrink: "0",
  '&[data-state="checked"]': {
    color: "$primary100main",
    border: "unset"
  },
  "&:disabled": {
    background: "$coreGreys20",
    borderColor: "$coreGreys20"
  }
}), t = r({
  paddingInlineStart: "0.6875rem",
  marginLeft: 0,
  marginRight: 0,
  variants: {
    disabled: {
      true: {
        color: "$coreGreys50"
      }
    }
  }
});
export {
  i as checkBoxStyles,
  o as containerStyles,
  t as labelStyles
};
//# sourceMappingURL=Checkbox.styles.es.js.map
